import { LocalStorageKeys } from '@authentication/constants';

import axiosClient from '@services/api';
import axios, { AxiosResponse } from 'axios';

import { Navigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import LoginResponse from '@authentication/models/login.response.dto';
import { destroyUserCache, getItem } from '@/lib/storageUtil';
import EndPoints from '@services/endpoints';
import LoginRequest from '@authentication/models/login.request.dto';
export const login = (
  data: LoginRequest,
): Promise<AxiosResponse<LoginResponse, any>> => {
  return axiosClient.post(EndPoints.auth.loginHostess, data);
};

const refreshToken = getItem(LocalStorageKeys.REFRESH_TOKEN);

export const refreshAccessToken = (): Promise<LoginResponse> => {
  return axios
    .post(
      `${EndPoints.auth.refreshAccessToken}`,
      {
        refreshToken,
      },
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
        },
      },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((_) => {
      destroyUserCache();
      Navigate({ to: Paths.LoginPage });
    });
};
